import { Box } from "@mantine/core";
import { ReactNode } from "react";

export const Spacer = ({ children }: { children: ReactNode[] }) => {
  if (!children) throw new Error("Spacer must have children");
  return (
    <Box>
      {children.map((child, index) => {
        return (
          <Box key={index} mb={"sm"}>
            {child}
          </Box>
        );
      })}
    </Box>
  );
};
